import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {highlightBackend} from "../services/highlight.backend";
import {Observable} from "rxjs";
import { Injectable } from "@angular/core";

@Injectable()
export class MockHttpInterceptor implements HttpInterceptor {
  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let url: string = request.url;
    let method: string = request.method;

    return highlightBackend(url, method, request)
        //|| factoidBackend(url, method, request)
        || next.handle(request);
  }
}
